<script setup lang="ts">
import { PATH_SECTORS_CODE } from "../constants";
import { useSectorStore } from "~/modules/sector/stores/useSectorStore";

const router = useRouter();

const { sectors } = useSectorStore();

// redirect to the root sector
if (sectors) {
  router.replace({
    name: PATH_SECTORS_CODE,
    params: { code: sectors.code },
  });
}
</script>

<template>
  <page-component />
</template>
